<template>
  <!-- <div class="profile-home">
     <div class="row profile-home__content">
        <div class="col-4 item">
            <div>
                <img src="@/assets/img/img-hts1.png" alt="">
                <div class="item__name">
                    <h3 class="font-size-24 font-sanpro-semibold">Sách điện tử của tôi</h3>
                </div>
            </div>
        </div>
        <div class="col-4 item">
            <img src="@/assets/img/img-hts2.png" alt="">
            <div class="item__name">
                <h3 class="font-size-24 font-sanpro-semibold">Cùng bạn luyện tập</h3>
            </div>
        </div>
        <div class="col-4 item">
            <img src="@/assets/img/img-hts3.png" alt="">
             <div class="item__name">
               <h3 class="font-size-24 font-sanpro-semibold">Lớp học của tôi</h3>
            </div>
        </div>
        <div class="col-4 item">
            <img src="@/assets/img/img-hts4.png" alt="">
             <div class="item__name">
                <h3 class="font-size-24 font-sanpro-semibold">Câu hỏi của tôi</h3>
            </div>
        </div>
        <div class="col-4 item">
            <img src="@/assets/img/img-hts1.png" alt="">
             <div class="item__name">
                <h3 class="font-size-24 font-sanpro-semibold">Sách điện tử của bạn</h3>
            </div>
        </div>
     </div>
  </div> -->
  
  	<div class="ss-data list__box__body list__box__body--grid exercise-subject__list">
		<div class="box_content">
			<div class="row">
                <div class="display-flex activity-profile__top col-12 mb-4">
                    <div class="form-group select-status select-status--class">
                        <select class="form-control" id="status" v-model="selectClaass" @change="handleSelectClaass">
                            <option value="0">Lớp - Tất cả</option>
                            <option  v-for="(option,index) of getListClass" 
                            :key="index"
                            :value="option.classId"
                            >{{option.name}}</option>
                           
                        </select>
                        <i class="fa fa-angle-down"></i>
                    </div>
                    <div class="form-group select-status">
                        <select class="form-control" id="status" v-model="selectTypeBook" @change="handleSelectTypeBook">
                            <option value="0">Loại sách - Tất cả</option>
                            <option  v-for="(option,index) of getListBookType"
                            :key="index"
                            v-bind:value="option.bookTypeId"
                            >Lớp {{option.name}}</option>
                         
                        </select>
                        <i class="fa fa-angle-down"></i>
                    </div>
                </div>
                <template v-if=" dataGetMyEbookList && dataGetMyEbookList.length >0">
                    <div 
                        class="item col-xl-3 col-lg-4 col-md-4 col-sm-6"
                        v-for="(itemBook, index) of dataGetMyEbookList"
                        :key="index"
                    >
                        <!-- <div class="item__wrap text-center"> -->
                            <ItemBook :itemBook="itemBook" />
                            <!-- <a href="javascript:;" class="item__deactive" @click="handleDeactiveBook(itemBook)">
                                Hủy kích hoạt
                            </a>
                        </div> -->
                    </div>
                </template>
            <div class="col-12 m-3 secondary-color-txt text-center" v-if="dataGetMyEbookList  && dataGetMyEbookList.length ==0">
                    Chưa có sách nào được kích hoạt
            </div>
			</div>
			<!-- <div class="row" v-else>
			<div class="col-12 m-3 secondary-color-txt text-center">
				Đang cập nhật sách lên hệ thống
			</div>
			</div> -->
              <div id="HomeProfile"></div>
              <div id="end_HomeProfile"></div>
            <!-- <p class="col-12 text-center pagiination-training">
                <Pagination
                @eventPagination="getClassPagination"
                :totalPage="pagingData.totalPage"
                :page="pagingData.pageIndex"
                />
            </p> -->
		</div>
        <!-- <ModalConfirmDeactiveBook
            :dataDeactive="dataBookDeactive"
            @cancle="() => dataBookDeactive = {}"
            @done="fetchListelEctricBooks()"
        /> -->
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import Pagination from "@/components/Pagination.vue";
import { APP_CONFIG } from "@/utils/constants";
import ItemBook from '../../../ebooks/_components/ebooklist/ItemBook'
// import { ID_MODAL_CONFIRM_DEACTIVE_BOOK } from './../../_store/constants'
// import ModalConfirmDeactiveBook from './ModalConfirmDeactiveBook'

export default {
    name:"HomeProfile",
    components: {
        Pagination,
        ItemBook
        // ModalConfirmDeactiveBook
    },
    data(){
        return{
            dataGetMyEbookList:[],
            elmEndItem:null,
            elmEndItem2:null,
            cdnUrl: APP_CONFIG.cdnUrl,
            selectClaass:0,
            selectTypeBook:0,
            pagingData:{},
            dataBookDeactive: {} // bookId, esStampId
        }
    },
    computed: {
        ...mapGetters({
            getParamListelEctricBooks: STORE_KEY + "/getParamListelEctricBooks",
            getMyEbookList: STORE_KEY + "/getMyEbookList",
            getListClass: STORE_KEY + "/getListClass",
            getListBookType: STORE_KEY + "/getListBookType",
        })
    },
    mounted(){

        this.elmEndItem = document.getElementById('HomeProfile')
        // this.elmEndItem2 = document.getElementById('end_HomeProfile')
        
            if (this.elmEndItem) {
                this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
                this.observer.observe(this.elmEndItem)
        }
          this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, pageIndex: 1, pageSize:10,BookTypeId:0,ClassId:0,sort:"",direction:"",keyword:""});
          this.actionGetListClasses(); 
          this.actionGetListBookType();
    },
    watch:{
        getMyEbookList(newVal,oldVal){
            if(newVal){
                this.pagingData = newVal.paging; 
            }
        },
        getParamListelEctricBooks: "fetchListelEctricBooks"
    },
    methods:{
        ...mapActions(`${STORE_KEY}`, ["actionSetParamListEctricBooks","actionListMyEbook","actionGetListClasses","actionGetListBookType"]),
         ...mapActions(`common`, ["setLoading"]),
        thumbUrl(filename) {
			return require(`@/assets/img/${filename}`);
        },
        handleSelectClaass(){
            this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, ClassId:this.selectClaass});
        },
        handleSelectTypeBook(){
             this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, BookTypeId:this.selectTypeBook});
        },
        fetchListelEctricBooks(){
            this.setLoading(true);
            this.actionListMyEbook(this.getParamListelEctricBooks).then(res=>{
                this.dataGetMyEbookList  = this.getParamListelEctricBooks.pageIndex === 1 ?res.list : [...this.dataGetMyEbookList, ...res.list];
            })
            .finally(() => {
                this.setLoading(false);
            });
        },
        getClassPagination(value) {
            this.setLoading(true);
            this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, pageIndex: value }).finally(
                () => {
                this.setLoading(false);
                }
            );
        },
        handleScrollEnd(){
            if( this.pagingData && this.pagingData.totalPage && this.getParamListelEctricBooks.pageIndex < this.pagingData.totalPage){
                
                this.actionSetParamListEctricBooks({...this.getParamListelEctricBooks, pageIndex: this.getParamListelEctricBooks.pageIndex + 1})
            }
        },

        // handleDeactiveBook (book) {
        //     if (!book || !book.bookId || !book.esStampId) {
        //         return
        //     }
        //     const { bookId, esStampId } = book
        //     this.dataBookDeactive = { bookId, esStampId }
        //     this.$bvModal.show(ID_MODAL_CONFIRM_DEACTIVE_BOOK)
        // }
    }
}
</script>

<style lang="scss" scoped>
    .select-status{
        position: relative;
        margin-right: 20px;
        select{
            border: none;
            background: #f3f6fb;
            border-radius: 20px;
            height: 30px;
            font-size: 15px;
            -webkit-appearance: none;
            width: 184px;

            @media screen and ( max-width: 575px ) {

                &--class {
                    width: 125px;
                }
            }
        }
        i{
            position: absolute;
            top: 7px;
            right: 15px;
        }
    }
// .profile-home{
//     &__content{
//         margin-top: 35px;
//         .item{
//             margin-bottom:35px;
//             position: relative;
//             &:hover{
//                 opacity: .8;
//             }
//             &__name{
//                 text-align: center;
//                 position: absolute;
//                 bottom: 23px;
//                 left: 95px;
//                 h3{
//                     color:#fff
//                 }
//             }
//         }
//     }
//     img{

//     }
// }
</style>